var nativeIsArray = Array.isArray
var toString = Object.prototype.toString

module.exports = nativeIsArray || isArray

function isArray(obj) {
    return toString.call(obj) === "[object Array]"
}



//////////////////
// WEBPACK FOOTER
// ./~/x-is-array/index.js
// module id = 27
// module chunks = 0